import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import {
    FAVORITES_UPDATED_EVENT,
    readFavoritesFromStorage,
    writeFavoritesToStorage,
} from '@/lib/favorites';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default function useFavorites() {
    const [favorites, setFavorites] = useState([]);
    const [isHydrated, setHydrated] = useState(false);

    const syncFavorites = useCallback(() => {
        const stored = readFavoritesFromStorage();
        setFavorites(stored);
        setHydrated(true);
    }, []);

    useIsomorphicLayoutEffect(() => {
        syncFavorites();
        window.addEventListener(FAVORITES_UPDATED_EVENT, syncFavorites);
        return () => window.removeEventListener(FAVORITES_UPDATED_EVENT, syncFavorites);
    }, [syncFavorites]);

    const isFavorite = useCallback((id) => {
        if (!id) {
            return false;
        }
        return favorites.some((item) => item.id === id);
    }, [favorites]);

    const toggleFavorite = useCallback((favoriteItem) => {
        if (!favoriteItem || !favoriteItem.id) {
            return;
        }
        const current = readFavoritesFromStorage();
        const exists = current.some((item) => item.id === favoriteItem.id);
        const updated = exists
            ? current.filter((item) => item.id !== favoriteItem.id)
            : [...current, favoriteItem];
        writeFavoritesToStorage(updated);
    }, []);

    return {
        favorites,
        count: favorites.length,
        isHydrated,
        isFavorite,
        toggleFavorite,
    };
}
